import { Tabs, Tab, Box, Typography } from '@mui/material';
import { useState } from 'react';
import Branding from './pages/Branding';
import Domain from './pages/Domain';

export default function BrandingAndDomain() {
  const [tab, setTab] = useState(0);

  return (
    <Box className='p-6'>
      <Typography variant='h6' fontWeight='bold' display='flex' alignItems='center' gap={1}>
        Branding & Domain
      </Typography>
      <p className='text-gray-500 mb-4'>Customize your business identity and domain settings.</p>

      <Tabs value={tab} onChange={(_, val) => setTab(val)} sx={{ mt: 2, mb: 2 }}>
        <Tab label='Branding' />
        <Tab label='Domain' />
      </Tabs>

      {tab === 0 && <Branding />}
      {tab === 1 && <Domain />}
    </Box>
  );
}
